import { optionalEnum, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.patient.PatientStatus
 */
export const PatientStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  DEDUCTION_PENDING: 'DEDUCTION_PENDING',
  INACTIVE: 'INACTIVE',
});

/**
 * Mirrors com.medprompt.patient.Patient
 *
 * @typedef {object} PatientData
 * @property {string|null} title
 * @property {string|null} name
 * @property {string|null} address
 * @property {string|null} phoneNumber
 * @property {string|null} email
 * @property {string|null} sex
 * @property {string|null} dateOfBirth
 * @property {string|null} status
 * @property {string|null} nhsId
 * @property {string|null} patientId
 */

/**
 * @param {object} raw
 * @returns {PatientData}
 */
export function fromPatientData(raw) {
  const source = requireObject(raw, 'Patient');
  return {
    title: optionalString(source.title),
    name: optionalString(source.name),
    address: optionalString(source.address),
    phoneNumber: optionalString(source.phoneNumber),
    email: optionalString(source.email),
    sex: optionalString(source.sex),
    dateOfBirth: optionalString(source.dateOfBirth),
    status: optionalEnum(source.status, PatientStatus, 'Patient', 'status'),
    nhsId: optionalString(source.nhsId),
    patientId: optionalString(source.patientId),
  };
}
